import { useSelector } from "react-redux";
import { languages } from "../config/config";

export default () => {
  const language = useSelector((state) => state.content?.language);

  const isArabic = language === languages?.arb;

  const TextWeight = {
    bold: isArabic ? "almarai-bold" : "avenir-heavy",
    regular: isArabic ? "almarai-regular" : "avenir-regular",
    medium: isArabic ? "almarai-regular" : "avenir-medium",
    light: isArabic ? "almarai-light" : "avenir-light",
    extraBold: isArabic ? "almarai-extra-bold" : "avenir-black",

    headingBold: isArabic ? "almarai-bold" : "butler-bold",
    headingSemibold: isArabic ? "almarai-bold" : "butler-semibold",
    headingRegular: isArabic ? "almarai-regular" : "butler-regular",
    headingLight: isArabic ? "almarai-light" : "butler-light",
    headingExtraBold: isArabic ? "almarai-extra-bold" : "almarai-light",

    playfairBold: isArabic ? "almarai-bold" : "playfair-display-bold",
    playfairRegular: isArabic ? "almarai-regular" : "playfair-display-regular",
    playfairMedium: isArabic ? "almarai-regular" : "playfair-display-medium",
    playfairBlack: isArabic ? "almarai-extra-bold" : "playfair-display-black",
    playfairExtraBold: isArabic ? "almarai-extra-bold" : "playfair-display-extra-bold",
    playfairSemiBold: isArabic ? "almarai-bold" : "playfair-display-semi-bold",

    sarSymbol: 'SaudiRiyalRegular',
  };

  const TextAlign = isArabic ? "text-right" : "text-left";

  return { isArabic, TextWeight, TextAlign };
};
